//Api Calidad
export const urlApi = process.env.REACT_APP_URLAPI;

// export const urlApi = `http://10.8.7.179/directorio-back/public/api/`;

//Api Producción 

// export const urlApi = `-------`;